$(document).ready(function(){
    if($('.warnings-container').find('.alert-warning, .alert-info, .alert-success, .alert-danger').length > 0){
        $('.warnings-container').removeClass('d-none');
    }
});
